<ng-container [ngSwitch]="(sectionData$ | async)?.rendererType | rendererTypeNormalizer">
  <ng-container *ngSwitchCase="'grid'">
    <ngx-grid-renderer [data]="sectionData$ | async"></ngx-grid-renderer>
  </ng-container>
  <ng-container *ngSwitchCase="'banner'">
    <kve-banner-renderer [data]="sectionData$ | async"></kve-banner-renderer>
  </ng-container>
  <ng-container *ngSwitchCase="'rich-text'">
    <kw-rich-text-renderer [data]="sectionData$ | async"></kw-rich-text-renderer>
  </ng-container>
  <ng-container *ngSwitchCase="'row'">
    <kw-row-renderer [data]="sectionData$ | async"></kw-row-renderer>
  </ng-container>
  <ng-container *ngSwitchCase="'hero-image'">
    <kw-hero-image-renderer [data]="sectionData$ | async"></kw-hero-image-renderer>
  </ng-container>
  <ng-container *ngSwitchDefault>
    <default-section-preview [sectionData]="sectionData$ | async"></default-section-preview>
  </ng-container>
</ng-container>
<!-- <div *ngIf="sectionData$ | async as sectionData" [class]="themeName" style="background-color: var(--background-page-color);">
    <ng-container [ngSwitch]="sectionData.rendererType | rendererTypeNormalizer">
      <ng-container *ngSwitchCase="'grid'">
        <ngx-grid-renderer [data]="sectionData"></ngx-grid-renderer>
      </ng-container>
      <ng-container *ngSwitchCase="'banner'">
        <kve-banner-renderer [data]="sectionData"></kve-banner-renderer>
      </ng-container>
      <ng-container *ngSwitchCase="'rich-text'">
        <kw-rich-text-renderer [data]="sectionData"></kw-rich-text-renderer>
      </ng-container>
      <ng-container *ngSwitchCase="'row'">
        <kw-row-renderer [data]="sectionData"></kw-row-renderer>
      </ng-container>
      <ng-container *ngSwitchCase="'hero-image'">
        <kw-hero-image-renderer [data]="sectionData"></kw-hero-image-renderer>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <default-section-preview [sectionData]="sectionData"></default-section-preview>
      </ng-container>
    </ng-container>
  </div> -->

  <!--
  switch (this.sectionData.rendererType as RendererType | string) {
        case RendererType.BANNER:
        case "RendererType.BANNER":
        case "banner":
            this.sectionOptions = this.sectionData.bannerOptions;
            this.sectionOptionsType = "bannerOptions";             
            break;
        case RendererType.BLOGLIST:
        case "RendererType.BLOGLIST":
        case "bloglist":
            this.sectionOptions = this.sectionData.blogListOptions;
            this.sectionOptionsType = "blogListOptions";
            break;
        case RendererType.GRID:
            this.sectionOptions = this.sectionData.gridOptions;
            this.sectionOptionsType = "gridOptions";
            break;
        case RendererType.HEROIMAGE:
        case "RendererType.HEROIMAGE":
        case "hero-image":
            this.sectionOptions = this.sectionData.bannerOptions;
            this.sectionOptionsType = "bannerOptions";
            break;
        case RendererType.NEWSLETTER:
        case "RendererType.NEWSLETTER":
        case "news-letter-sign-up":
            this.sectionOptions = this.sectionData.rowOptions;
            this.sectionOptionsType = "rowOptions";
            break;
        case RendererType.RICH_TEXT:
        case "RendererType.RICH_TEXT":
        case "rich-text": 
            console.log("Getting RICH")
            this.sectionOptions = this.sectionData.richTextOptions;
            this.sectionOptionsType = "richTextOptions";
            break;
        case RendererType.ROW:
        case "RendererType.ROW":
        case "row":
        case RendererType.SLIDER:
        case "RendererType.SLIDER":
        case "slider":
        case RendererType.CART:
        case "RendererType.CART":
        case "cart":
        case RendererType.CATEGORY:
        case "RendererType.CATEGORY":
        case "category":
        case RendererType.PRODUCT:
        case "RendererType.PRODUCT":
        case "product":
        case RendererType.STOREFEATURES:
        case "RendererType.STOREFEATURES":
        case "store-features":
            this.sectionOptions = this.sectionData.rowOptions;
            this.sectionOptionsType = "rowOptions";
            break;
        case RendererType.TESTIMONIALS:
        case "RendererType.TESTIMONIALS":
        case "testimonials":
            this.sectionOptions = this.sectionData.testimonialOptions;
            this.sectionOptionsType = "testimonialOptions";
            break;
        case RendererType.BLOG:
        case "RendererType.BLOG":
        case "blog":
            this.sectionOptions = this.sectionData.blogListOptions;
            this.sectionOptionsType = "blogListOptions";
            break;
        default:
          console.log(`Got no hit for ${this.sectionData.rendererType}`)
            break;
    }
  -->
